import Flickity from "flickity";
require('flickity-fade');

export default function () {
  const clientsCarousels = document.querySelectorAll('.js-clients-carousel');
  const testimonials = document.querySelectorAll('.testimonials__holder');
  const logos = document.querySelectorAll('.logo-block__logos-list');
  const isMobile = window.innerWidth <= 768;

  if (clientsCarousels) {
    clientsCarousels.forEach(function (elem, index) {
      if (elem) {
        let carouselOptions = {
          prevNextButtons: false,
          // autoPlay: isMobile ? false : 4000,
          pageDots: false,
          freeScroll: true,
          wrapAround: true
        };

        const flkty = new Flickity(elem, carouselOptions);

        const prevButton = elem.closest('.carousel-container').querySelector('.button--previous');
        const nextButton = elem.closest('.carousel-container').querySelector('.button--next');

        if (prevButton && nextButton) {
          prevButton.addEventListener('click', function() {
            flkty.previous();
          });

          nextButton.addEventListener('click', function() {
            flkty.next();
          });
        }
      }
    });
  }

  if (logos) {
    logos.forEach(function (elem, index) {
      if (elem) {
        let carouselOptions = {
          prevNextButtons: false,
          // autoPlay: isMobile ? false : 4000,
          pageDots: false,
          freeScroll: true,
          wrapAround: true
        };

        const flkty = new Flickity(elem, carouselOptions);

        const prevButton = elem.closest('.carousel-container').querySelector('.button--previous');
        const nextButton = elem.closest('.carousel-container').querySelector('.button--next');

        if (prevButton && nextButton) {
          prevButton.addEventListener('click', function() {
            flkty.previous();
          });

          nextButton.addEventListener('click', function() {
            flkty.next();
          });
        }
      }
    });
  }

  if (testimonials) {
    testimonials.forEach(function (elem, index) {
      if (elem) {
        let carouselOptions = {
          prevNextButtons: false,
          // autoPlay: isMobile ? false : 4000,
          pageDots: elem.children.length > 1
        };

        const flkty = new Flickity(elem, carouselOptions);

        const prevButton = elem.closest('.carousel-container').querySelector('.button--previous');
        const nextButton = elem.closest('.carousel-container').querySelector('.button--next');

        if (prevButton && nextButton) {
          prevButton.addEventListener('click', function() {
            flkty.previous();
          });

          nextButton.addEventListener('click', function() {
            flkty.next();
          });
        }
      }
    });
  }
}
